"use client"

import { useState, useEffect } from "react"
import { Share2Icon, Trash2Icon, ViewIcon, Copy, Check } from "lucide-react"
import type { Project } from "../../../lib/types"
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger, } from "../../../components/ui/dialog";
import { Button } from "../../../components/ui/button";
import { Input } from "../../../components/ui/input";

interface ProjectCardProps {
  project2: Project2
}

type Project2 = {
  id: number
  title: string
  thumbnail: string
  description: string
  category: string
  rating?: number
  createdAt?: string
  tags?: string[]
  author?: string
  status?: "active" | "draft" | "archived"
  sport_id: string
  svg_path: string
  id_data: number
  shared: string
  body_state: boolean
  socks_state: boolean
  up_state: boolean
  down_state: boolean
  clone_state: boolean
  images: any
  inside_color: string
  up_state2: boolean
  collar: string
}

export function ProjectCard({ project2 }: ProjectCardProps) {
  const [sharedUrl, setSharedUrl] = useState("")
  const [copied, setCopied] = useState(false)

  useEffect(() => {
    const interval = setInterval(() => {
      const url = (window as any).urlCurrent
      if (url && url !== sharedUrl) setSharedUrl(url)
    }, 500)
    return () => clearInterval(interval)
  }, [sharedUrl])

  return (
    <div className="group relative overflow-hidden rounded-lg border border-border bg-card transition-all hover:border-primary/40 hover:bg-accent">
      {/* Thumbnail */}
      <div className="relative aspect-[4/3] overflow-hidden bg-secondary/50">
        <img
          src={project2.thumbnail}
          alt={`Thumbnail do projeto ${project2.title}`}
          className="size-full object-cover transition-transform group-hover:scale-105"
          crossOrigin="anonymous"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-card/60 to-transparent opacity-0 transition-opacity group-hover:opacity-100" />


        <div className="cursor-pointer absolute right-[5px] bottom-2 flex size-8 items-center justify-center rounded-full bg-destructive text-primary-foreground opacity-1 transition-opacity group-hover:opacity-100">
          <Trash2Icon className="size-4" />
        </div>
        {/**<div
          data-sport={project2.sport_id}
          data-svg={project2.svg_path}
          data-body={project2.body_state}
          data-socks={project2.socks_state}
          data-up={project2.up_state}
          data-up2={project2.up_state2}
          data-collar={project2.collar}
          data-down={project2.down_state}
          data-clone={project2.clone_state}
          data-id={project2.id_data}
          data-insidecolor={project2.inside_color}
          className="view-share cursor-pointer absolute right-[45px] bottom-2 flex size-8 items-center justify-center rounded-full bg-primary/80 text-primary-foreground opacity-1 transition-opacity group-hover:opacity-100">
          <Share2Icon className="size-4" />
        </div> */}
        {!project2.shared ?
          <Dialog>
            <DialogTrigger asChild>
              <Button
                size="sm"
                variant="outline"
                className={`view-share cursor-pointer absolute right-[45px] bottom-2 flex size-8 items-center justify-center rounded-full bg-primary/80 text-primary-foreground opacity-1 transition-opacity group-hover:opacity-100`}
                data-sport={project2.sport_id}
                data-svg={project2.svg_path}
                data-body={project2.body_state}
                data-socks={project2.socks_state}
                data-up={project2.up_state}
                data-up2={project2.up_state2}
                data-collar={project2.collar}
                data-down={project2.down_state}
                data-clone={project2.clone_state}
                data-id={project2.id_data}
                data-insidecolor={project2.inside_color}
              >
                <Share2Icon className="h-4 w-4" />
              </Button>
            </DialogTrigger>
            <DialogContent>
              <DialogHeader>
                <DialogTitle>Compartilhar: {project2.title}</DialogTitle>
                <DialogDescription>
                  Você pode escolher compartilhar o projeto para visualização ou edição.
                </DialogDescription>
              </DialogHeader>
              <div className="mt-4 space-y-4">
                <div id="qrcodeNew"></div>
                {sharedUrl && (
                  <div className="flex items-center gap-2">
                    <Input
                      readOnly
                      value={sharedUrl}
                      className="text-xs text-muted-foreground flex-1 font-mono"
                      onClick={(e) => (e.target as HTMLInputElement).select()}
                    />
                    <Button
                      size="sm"
                      variant="outline"
                      onClick={() => {
                        navigator.clipboard.writeText(sharedUrl)
                        setCopied(true)
                        setTimeout(() => setCopied(false), 2000)
                      }}
                    >
                      {copied ? <Check className="w-4 h-4" /> : <Copy className="w-4 h-4" />}
                      <span className="text-xs">{copied ? "Copiado!" : "Copiar link"}</span>
                    </Button>
                  </div>
                )}
                <div className="flex flex-col justify-center items-center">
                  <Button size="sm" className="flex-1 p-2 m-2 w-[fit-content]" id="qrcode-link-new2">
                    <Share2Icon className="mr-2 h-4 w-4" />
                    Copiar link de visualização para compartilhar33
                  </Button>
                  <Button size="sm" className="flex-1 p-2 m-2 w-[fit-content]" id="qrcode-link-new">
                    <Share2Icon className="mr-2 h-4 w-4" />
                    Copiar link de edição para compartilhar
                  </Button>
                </div>
              </div>
            </DialogContent>
          </Dialog>
          : null}
        <div
          data-sport={project2.sport_id}
          data-svg={project2.svg_path}
          data-body={project2.body_state}
          data-socks={project2.socks_state}
          data-up2={project2.up_state2}
          data-collar={project2.collar}
          data-up={project2.up_state}
          data-down={project2.down_state}
          data-clone={project2.clone_state}
          data-id={project2.id_data}
          data-insidecolor={project2.inside_color}
          className="view-saved cursor-pointer absolute right-[85px] bottom-2 flex size-8 items-center justify-center rounded-full bg-primary/80 text-primary-foreground opacity-1 transition-opacity group-hover:opacity-100">
          <ViewIcon className="size-4" />
        </div>
      </div>

      {/* Info */}
      <div className="px-3 py-3">
        <p className="truncate text-sm font-medium text-foreground">
          {project2.title}
        </p>
        {/**<p className="text-xs text-muted-foreground">
          {project2.createdAt && (
            <>Criado em {new Date(project2.createdAt).toLocaleDateString("pt-BR")}</>
          )}
        </p> */}
      </div>
    </div>
  )
}
